module.exports = __webpack_public_path__ + "img/add-dashed-circle-no-loop.23f7df88.gif";